import { actualizaPaqueteMayorista, agregarDescuentoPaqueteMayorista, deleteImagenTipoPaqueteMayorista, getGaleriaTipoPaqueteMayorista, getListaPreciosPaqueteMayorista, getPaqueteMayorista, getPaquetesMayoristaAll, getPaquetesMayoristaAllDetalle, getProveedorTerrestreLista, newImagenTipoPaqueteMayorista, newPaqueteMayorista, obtenerDescuentosPaqueteMayorista } from "../services/packageService"

//TODO: Este documento pertenece al nuevo flujo de paquetes mayoristas
const dataInicial = {
    arrayPaquetesMayorista: [],
    total: 0,
    pagina: 0,
    registros: 10,
    busqueda: "NA",
    exito: 0,
    listaTerrestres: [],
    listaCircuitosDetalle: [],
    galeria: [],
    totalDetalle: 0,
    mayoristaSelect: {},
    listaDescuentos: [],
    listaPrecios: [],
    totalDescuentos: 0

}
const OBTENER_PAQUETE_MAYORISTA_ALL_ACTION = "OBTENER_PAQUETE_MAYORISTA_ALL"
const OBTENER_PAQUETE_MAYORISTA_PAGINA_ACTION = "OBTENER_PAQUETE_MAYORISTA_PAGINA_ACTION"
const OBTENER_PAQUETE_MAYORISTA_REGISTROS_ACTION = "OBTENER_PAQUETE_MAYORISTA_REGISTROS_ACTION"
const OBTENER_PAQUETE_MAYORISTA_BUSQUEDA_ACTION = "OBTENER_PAQUETE_MAYORISTA_BUSQUEDA_ACTION"
const NUEVO_PAQUETE_MAYORISTA_ACTION = "NUEVO_PAQUETE_MAYORISTA_ACTION"
const ACTUALIZA_PAQUETE_MAYOTISTA_ACTION = "ACTUALIZA_PAQUETE_MAYOTISTA_ACTION"
const NUEVO_PAQUETE_MAYORISTA_TIPO_IMAGEN = "NUEVO_PAQUETE_MAYORISTA_TIPO_IMAGEN"
const DELETE_PAQUETE_MAYORISTA_TIPO_IMAGEN = "DELETE_PAQUETE_MAYORISTA_TIPO_IMAGEN"
const OBTENER_PAQUETE_MAYORISTA_GALERIA = "OBTENER_PAQUETE_MAYORISTA_GALERIA"
//* Paquete terrestre
const OBTENER_PAQUETE_MAYORISTA_TERRESTRES_ACTION = "OBTENER_PAQUETE_MAYORISTA_TERRESTRES_ACTION"

//* Paquete Mayorista Update
const OBTENER_PAQUETE_MAYORISTA_LISTA_DETALLE = "OBTENER_PAQUETE_MAYORISTA_LISTA_DETALLE";

const OBTENER_DESCUENTOS_PAQUETE_MAYORISTA_ACTION = "OBTENER_DESCUENTOS_PAQUETE_MAYORISTA_ACTION"
const OBTENER_LISTA_PRECIOS_PAQUETE_MAYORISTA_ACTION = "OBTENER_LISTA_PRECIOS_PAQUETE_MAYORISTA_ACTION"
const AGREGAR_DESCUENTO_PAQUETE_MAYORISTA_ACTION = "AGREGAR_DESCUENTO_PAQUETE_MAYORISTA_ACTION"
const OBTENER_PAQUETE_MAYORISTA_ACTION = "OBTENER_PAQUETE_MAYORISTA_ACTION"


export default function proveedorMayoristaReducer(state = dataInicial, action) {
    if (action.type === OBTENER_PAQUETE_MAYORISTA_ALL_ACTION)
        return { ...state, arrayPaquetesMayorista: action.payload.arrayPaquetesMayorista, total: action.payload.total }
    if (action.type === OBTENER_PAQUETE_MAYORISTA_PAGINA_ACTION)
        return { ...state, arrayPaquetesMayorista: action.payload.arrayPaquetesMayorista, total: action.payload.total, pagina: action.payload.pagina }
    if (action.type === OBTENER_PAQUETE_MAYORISTA_REGISTROS_ACTION)
        return { ...state, arrayPaquetesMayorista: action.payload.arrayPaquetesMayorista, total: action.payload.total, registros: action.payload.registros }
    if (action.type === OBTENER_PAQUETE_MAYORISTA_BUSQUEDA_ACTION)
        return { ...state, arrayPaquetesMayorista: action.payload.arrayPaquetesMayorista, total: action.payload.total, pagina: action.payload.pagina, registros: action.payload.registros, busqueda: action.payload.busqueda }
    if (action.type === NUEVO_PAQUETE_MAYORISTA_ACTION)
        return { ...state, exito: action.payload.exito }
    if (action.type === ACTUALIZA_PAQUETE_MAYOTISTA_ACTION)
        return { ...state, exito: action.payload.exito }
    //* Metodos adcionales al mayorista
    if (action.type === NUEVO_PAQUETE_MAYORISTA_TIPO_IMAGEN)
        return { ...state, exito: action.payload.exito }
    if (action.type === DELETE_PAQUETE_MAYORISTA_TIPO_IMAGEN)
        return { ...state, exito: action.payload.exito }
    if (action.type === OBTENER_PAQUETE_MAYORISTA_GALERIA)
        return { ...state, galeria: action.payload.galeria }
    if (action.type === OBTENER_PAQUETE_MAYORISTA_LISTA_DETALLE)
        return { ...state, listaCircuitosDetalle: action.payload.listaCircuitosDetalle, totalDetalle: action.payload.totalDetalle }
    if (action.type === AGREGAR_DESCUENTO_PAQUETE_MAYORISTA_ACTION)
        return { ...state, exito: action.payload.exito }
    if (action.type === OBTENER_PAQUETE_MAYORISTA_ACTION)
        return { ...state, exito: action.payload.exito, mayoristaSelect: action.payload.mayoristaSelect }
    if (action.type === OBTENER_LISTA_PRECIOS_PAQUETE_MAYORISTA_ACTION)
        return { ...state, listaPrecios: action.payload.listaPrecios }
    //* paquete terrestre
    if (action.type === OBTENER_PAQUETE_MAYORISTA_TERRESTRES_ACTION)
        return { ...state, listaTerrestres: action.payload.listaTerrestres }
    if (action.type === OBTENER_DESCUENTOS_PAQUETE_MAYORISTA_ACTION)
        return { ...state, listaDescuentos: action.payload.listaDescuentos }
    return { ...state }
}
export const obtenerPaqueteMayoristaAllAction = () => async (dispatch, getState) => {
    const { pagina, registros, busqueda } = getState().proveedorMayorista
    return await getPaquetesMayoristaAll({ IdProveedor: busqueda, Pagina: pagina + 1, Registros: registros }).then(Response => {
        dispatch({
            type: OBTENER_PAQUETE_MAYORISTA_ALL_ACTION,
            payload: {
                arrayPaquetesMayorista: Response.lPaquete,
                total: Response.total,
            }
        })
        return Response
    })
}
export const obtenerPaqueteMayoristaPaginaAction = ({ pagina }) => async (dispatch, getState) => {
    const { registros, busqueda } = getState().proveedorMayorista
    return await getPaquetesMayoristaAll({ IdProveedor: busqueda, Pagina: pagina + 1, Registros: registros }).then(Response => {
        dispatch({
            type: OBTENER_PAQUETE_MAYORISTA_PAGINA_ACTION,
            payload: {
                arrayPaquetesMayorista: Response.lPaquete,
                total: Response.total,
                pagina: pagina
            }
        })
        return Response
    })
}
export const obtenerPaqueteMayoristaRegistrosAction = ({ registros }) => async (dispatch, getState) => {
    const { pagina, busqueda } = getState().proveedorMayorista
    return await getPaquetesMayoristaAll({ IdProveedor: busqueda, Pagina: pagina + 1, Registros: registros }).then(Response => {
        dispatch({
            type: OBTENER_PAQUETE_MAYORISTA_REGISTROS_ACTION,
            payload: {
                arrayPaquetesMayorista: Response.lPaquete,
                total: Response.total,
                registros: registros
            }
        })
        return Response
    })
}
export const obtenerPaqueteMayoristaBusquedaProveedorAction = ({ busqueda }) => async (dispatch, getState) => {
    const { pagina, registros } = dataInicial
    return await getPaquetesMayoristaAll({ IdProveedor: busqueda, Pagina: pagina + 1, Registros: registros }).then(Response => {
        dispatch({
            type: OBTENER_PAQUETE_MAYORISTA_BUSQUEDA_ACTION,
            payload: {
                arrayPaquetesMayorista: Response.lPaquete,
                total: Response.total,
                registros: registros,
                pagina: pagina,
                busqueda: busqueda
            }
        })
        return Response
    })
}

export const obtenerPaqueteMayoristaAction = ({ IdPaqueteMayorista }) => async (dispatch) => {
    return await getPaqueteMayorista({ IdPaqueteMayorista }).then(Response => {
        dispatch({
            type: OBTENER_PAQUETE_MAYORISTA_ACTION,
            payload: {
                exito: 1,
                mayoristaSelect: Response
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}

export const obtenerListaPreciosPaqueteMayoristaAction = ({ IdPaqueteMayorista }) => async (dispatch) => {
    return await getListaPreciosPaqueteMayorista({ IdPaqueteMayorista }).then(Response => {
        dispatch({
            type: OBTENER_LISTA_PRECIOS_PAQUETE_MAYORISTA_ACTION,
            payload: {
                listaPrecios: Response
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })

}

export const crearPaqueteMayoritaAction = ({ 
    IdPaqueteProveedorTerrestre, 
    IdProveedorGrupoPaquete, 
    IdMoneda, 
    ClavePaquete, 
    Nombre, 
    PrecioPublico, 
    TipoCambioPrevisto,
    PaqueteMayoristaOferta,
    lPaqueteMayoristaUtilidad
}) => async (dispatch) => {
    return await newPaqueteMayorista({ 
        IdPaqueteProveedorTerrestre, 
        IdProveedorGrupoPaquete, 
        IdMoneda, 
        ClavePaquete, 
        Nombre,
        PrecioPublico, 
        TipoCambioPrevisto,
        PaqueteMayoristaOferta,
        lPaqueteMayoristaUtilidad
    }).then(Response => {
        dispatch({
            type: NUEVO_PAQUETE_MAYORISTA_ACTION,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const actualizaPaqueteMayoristaAction = ({ 
    IdPaqueteMayorista,
    IdPaqueteProveedorTerrestre, 
    IdProveedorGrupoPaquete, 
    IdMoneda, 
    ClavePaquete, 
    Nombre, 
    PrecioPublico, 
    TipoCambioPrevisto,
    Estatus, 
    PaqueteMayoristaOferta,
    lPaqueteMayoristaUtilidad
}) => async (dispatch) => {
    return await actualizaPaqueteMayorista({
        IdPaqueteMayorista, 
        IdPaqueteProveedorTerrestre, 
        IdProveedorGrupoPaquete, 
        IdMoneda, 
        ClavePaquete, 
        Nombre, 
        PrecioPublico, 
        TipoCambioPrevisto, 
        Estatus, 
        PaqueteMayoristaOferta,
        lPaqueteMayoristaUtilidad
    }).then(Response => {
        dispatch({
            type: ACTUALIZA_PAQUETE_MAYOTISTA_ACTION,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const obtenerPaqueteTerresteAction = () => async (dispatch) => {
    return await getProveedorTerrestreLista().then(Response => {
        dispatch({
            type: OBTENER_PAQUETE_MAYORISTA_TERRESTRES_ACTION,
            payload: {
                listaTerrestres: Response,
            }
        })
        return Response
    })
}

//* Metodos adicionales al mayorista
export const nuevaImagenTipoPaqueteMayorista = ({ extencion, idPaquete, tipoImagen, imagen }) => async (dispatch) => {
    return await newImagenTipoPaqueteMayorista({ ExtensionImagen: extencion, IdPaqueteMayorista: idPaquete, IdTipoImagen: tipoImagen, ImagenBase64: imagen }).then(Response => {
        dispatch({
            type: NUEVO_PAQUETE_MAYORISTA_TIPO_IMAGEN,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const elimarImagenTipoPaqueteMayorista = ({ idPaqueteMayoristaImagen }) => async (dispatch) => {
    return await deleteImagenTipoPaqueteMayorista({ IdPaqueteMayoristaImagen: idPaqueteMayoristaImagen }).then(Response => {
        dispatch({
            type: DELETE_PAQUETE_MAYORISTA_TIPO_IMAGEN,
            payload: {
                exito: 1
            }
        })
    }).catch(error => {
        return error
    })
}

export const obtenerGaleriaPaqueteMayoritaAction = ({ clavePaquete, tipo }) => async (dispatch) => {
    return await getGaleriaTipoPaqueteMayorista({ clavePaquete, tipo }).then(Response => {
        dispatch({
            type: OBTENER_PAQUETE_MAYORISTA_GALERIA,
            payload: {
                galeria: Response
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}


//* Medotos para la lista detalle de paquetes mayoristas (la que regresa todos los datos de los circuitos)
export const obetenerPaqueteMayoristaListaDetalle = () => async (dispatch, getState) => {
    const { pagina, registros } = getState().proveedorMayorista
    
    return await getPaquetesMayoristaAllDetalle({ Pagina: pagina + 1, Registros: registros }).then(Response => {
        dispatch({
            type: OBTENER_PAQUETE_MAYORISTA_LISTA_DETALLE,
            payload: {
                listaCircuitosDetalle: Response?.lPaquete,
                totalDetalle: Response?.Total
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}

export const obtenerPaqueteMayoristaPaginaDetalleAction = ({ pagina }) => async (dispatch, getState) => {
    const { registros } = getState().proveedorMayorista
    return await getPaquetesMayoristaAllDetalle({ Pagina: pagina + 1, Registros: registros }).then(Response => {
        dispatch({
            type: OBTENER_PAQUETE_MAYORISTA_LISTA_DETALLE,
            payload: {
                listaCircuitosDetalle: Response?.lPaquete,
                totalDetalle: Response?.Total
            }
        })
        return Response
    })
}

export const obtenerPaqueteMayoristaRegistrosDetalleAction = ({ registros }) => async (dispatch, getState) => {
    const { pagina} = getState().proveedorMayorista
    return await getPaquetesMayoristaAllDetalle({ Pagina: pagina + 1, Registros: registros }).then(Response => {
        dispatch({
            type: OBTENER_PAQUETE_MAYORISTA_LISTA_DETALLE,
            payload: {
                listaCircuitosDetalle: Response?.lPaquete,
                totalDetalle: Response?.Total
            }
        })
        return Response
    })
}


//* Metodos para los descuentos de paquetes mayoristas
export const obtenerDescuentosPaqueteMayoristaAction = ({ idProveedor }) => async (dispatch) => {
    return await obtenerDescuentosPaqueteMayorista({ IdProveedor: idProveedor }).then(Response => {
        dispatch({
            type: OBTENER_DESCUENTOS_PAQUETE_MAYORISTA_ACTION,
            payload: {
                listaDescuentos: Response?.lPaquete,
                totalDescuentos: Response?.Total
            }
        })
        return Response
    })
}

export const agregarDescuentoPaqueteMayoristaAction = ({ idProveedorGrupoPaquete, porcentaje, fechaLimite }) => async (dispatch) => {
    return await agregarDescuentoPaqueteMayorista({ IdProveedorGrupoPaquete: idProveedorGrupoPaquete, Porcentaje: porcentaje, FechaFin: fechaLimite }).then(Response => {
        dispatch({
            type: AGREGAR_DESCUENTO_PAQUETE_MAYORISTA_ACTION,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}